import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet, TouchableOpacity } from 'react-native'

import { Box } from 'widgets/Box'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { useMaxWidth } from 'hooks/useMaxWidth'

type EmojiButtonProps = {
  emoji: string
  title?: string
  subtitle?: string
  isSingleRow?: boolean
  onPress: () => void
}

export const EmojiButton = ({
  emoji,
  title,
  subtitle,
  isSingleRow = true,
  onPress,
}: EmojiButtonProps) => {
  const theme = useTheme()
  const { width: maxWidth } = useMaxWidth()

  const styles = StyleSheet.create({
    button: {
      width: isSingleRow ? '30%' : maxWidth * 0.4,
      height: isSingleRow ? 185 : maxWidth * 0.5,
      maxHeight: 200,
      backgroundColor: theme.colors.v2lightGrey,
      borderRadius: 10,
      marginHorizontal: isSingleRow ? 8 : 4,
    },
  })

  return (
    <TouchableOpacity style={styles.button} disabled={!title} onPress={onPress}>
      <Box
        flexDirection='column'
        align='center'
        margin={{ top: 'smd' }}
        padding='xs'
        justifyContent='center'
      >
        {isSingleRow ? (
          <Text fontSize='xxl'>{emoji}</Text>
        ) : (
          <Box height={maxWidth * 0.33} maxHeight={120} align='center' justifyContent='center'>
            <Title size='xxl'>{emoji}</Title>
          </Box>
        )}
        <Box
          margin={{
            top: !subtitle ? theme.spacing.sm : undefined,
            bottom: subtitle ? theme.spacing.sm : undefined,
          }}
        >
          {title ? (
            <Text black isCompact fontSize='md' align='center'>
              {title}
            </Text>
          ) : (
            <LoadingSpinner size='small' />
          )}
        </Box>
        {subtitle ? (
          <Text isCompact fontSize='xs' align='center'>
            {subtitle}
          </Text>
        ) : null}
      </Box>
    </TouchableOpacity>
  )
}
